const productRichSnippet = () => {
    const productObj = $('#productRichSnippet').data('productrichsnippet');
    let reviewsObj = {};
    let aggregateRating = '';
    let reviews = '';
    let richSnippet = {};

    if ($('#reviewsRichSnippet').length) {
        reviewsObj = $('#reviewsRichSnippet').data('reviewsrichsnippet');

        reviewsObj.reviews.forEach((value, index, array) => {
            reviews += `"review" : {
                "@type": "Review",
                "name": "${value.firstname} ${value.lastname}",
                "datePublished": "${value.publish_date}",
                "reviewBody": "${value.review}",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "${value.rate}"
                },
                "author": {
                    "@type": "Person",
                    "name": "unknown"
                },
                "publisher": {
                    "@type": "Organization",
                    "name": "Opiniones verificadas"
                }
            }`;

            if (array.length - 1 > index) {
                reviews += ',';
            }
        });

        aggregateRating = `
        "aggregateRating": {
            "@type": "AggregateRating", 
            "ratingValue": "${reviewsObj.ratingValue}",
            "reviewCount": "${reviewsObj.reviewCount}"
        },
        ${reviews}
        `;

        richSnippet = `{
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "${productObj ? productObj.name : ''}",
            "sku": "${productObj ? productObj.sku : ''}",
            "image": "${productObj ? productObj.image : ''}",
            "brand" : "${productObj ? productObj.brand : ''}",
            "description": "${productObj && productObj.description ? productObj.description : ''}",
            "url": "${productObj ? productObj.url : ''}",
            "mpn": "${productObj ? productObj.mpn : ''}",
            "offers":
            {
                "@type": "Offer",
                "priceCurrency": "${productObj && productObj.offers ? productObj.offers.priceCurrency : ''}",
                "price": "${productObj && productObj.offers ? productObj.offers.price : ''}",
                "itemCondition": "https://schema.org/NewCondition",
                "availability": "https://schema.org/InStock",
                "url": "${productObj && productObj.offers && productObj.offers.url ? productObj.offers.url : ''}"
            },
            ${aggregateRating}
        }`;
    } else {
        richSnippet = `{
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "${productObj.name}",
            "sku": "${productObj.sku}",
            "image": "${productObj.image}",
            "brand" : "${productObj.brand}",
            "description": "${productObj.description === undefined ? '' : productObj.description}",
            "url": "${productObj.url}",
            "mpn": "${productObj.mpn}",
            "offers":
            {
                "@type": "Offer",
                "priceCurrency": "${productObj.offers === undefined ? '' : productObj.offers.priceCurrency}",
                "price": "${productObj.offers === undefined ? '' : productObj.offers.price}",
                "itemCondition": "https://schema.org/NewCondition",
                "availability": "https://schema.org/InStock",
                "url": "${productObj.offers === undefined ? '' : productObj.offers.url}"
            }
        }`;
    }

    $('body').append(`<script type="application/ld+json">
        ${richSnippet}
    </script>`);
};

module.exports = {
    productRichSnippet,
};
